export const MIX_GRAPH_SECTION_WIDTH = 0.04;
export const MAX_GRAPH_SECTIONS = 4;
export const GRAPH_INCOME_SECTIONS_COLORS = ["bg-green-700", "bg-green-500", "bg-green-300", "bg-green-200"];
export const GRAPH_OUTCOME_SECTIONS_COLORS = ["bg-red-700", "bg-red-500", "bg-red-300", "bg-red-200"];
